'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'HazardClassesRestService',
    function($modal, HazardClassesRestService) {
        return {
            select: select,
            create: create,
            edit: edit,
            api: HazardClassesRestService,
        };

        function select(tax, filters, def) {
            return $modal.open({
                template: require('../view/hazard-classes-modal-select.html'),
                controller: 'HazardClassesModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return tax;
                    },
                    taxFilters: function() {
                        return filters != null ? filters : [];
                    },
                    def: () => {
                        return {
                            org: def.org,
                        };
                    },
                },
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/hazard-classes-modal-create.html'),
                controller: 'HazardClassesModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return {
                            org: (function(def) {
                                if (def != null && def.org != null) {
                                    return def.org;
                                }
                            })(def),
                        };
                    },
                },
            });
        }

        function edit(tax) {
            return $modal.open({
                template: require('../view/hazard-classes-modal-create.html'),
                controller: 'HazardClassesModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return tax;
                    },
                },
            });
        }
    }];
